import { useQuery } from 'react-query';
import client from 'client';

const fetchSession = async (eventId: number, sessionId: number) => {
    const response = await client().get(`/api/v2/agenda/events/${eventId}/sessions/${sessionId}`);
    return response.data;
};

const useSession = (eventId: number, sessionId: number) => {
    return useQuery(['session', eventId, sessionId], () => fetchSession(eventId, sessionId), {
        enabled: !!eventId && !!sessionId,
    });
};

export default useSession;
